import { clone, ISpineData, SpineBase, detectDeviceEnvironmentConstants, dispatcher, IEvent, ingenuity, IObject, Graphics } from "@quest/base-core";
import { FreeGameViewBehavior, SlotConstantsBehavior, SlotEventConstantsBehavior } from "@quest/murka-games-behavior-panther/dist";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { gameConstants } from "../Constants/gameConstants";


export class FreeGameView extends FreeGameViewBehavior {
  constructor(json: any) {
    super(json);
    ingenuity.deviceEnv.isDesktop && (this.getImageById("reelBGFg").mask = this.getShapeById("reelMask"));
  }
  protected subscibeEvents(): void {
    super.subscibeEvents();
    dispatcher.on(eventDispatchers.CREATE_WIN_MASK_FG, this.maskWinLayer, this);

  }
  protected unsubscribeEvents(): void {
    super.unsubscribeEvents();
    dispatcher.off(eventDispatchers.CREATE_WIN_MASK_FG, this.maskWinLayer, this);

    dispatcher.off(SlotEventConstantsBehavior.UPDATE_RETRIGER_NUMBER, this.UpdateFreeSpinCounterText, this);
  }
  /**
  * to add mask on win presentation layer
  */
  private maskWinLayer(): void {
    const winPanel = this.getWinReelView();
    for (let i = 0; i < ingenuity.configData.numberOfReel; i++) {
      winPanel.children[i].mask = this.getShapeById("winMasker") as Graphics
    }
  }

  /**
     * to show all symbols alpha which are present on grid
     */
  protected showAlpha(): void {
    if (this.reelView) {
      for (let reel = 0; reel < ingenuity.configData.numberOfReel; reel++) {
        for (let symbol = 0; symbol < 10; symbol++) {
          this.reelView.getSymbolByPos(reel, symbol).getStatic().tint = 0x5b5b5b;
        }
      }
    }
  }

  /**
   * to hide all symbols alpha which are present on grid
   */
  protected hideAlpha(): void {
    if (this.reelView) {
      for (let reel = 0; reel < ingenuity.configData.numberOfReel; reel++) {
        for (let symbol = 0; symbol < 10; symbol++) {
          this.reelView.getSymbolByPos(reel, symbol) && (this.reelView.getSymbolByPos(reel, symbol).getStatic().tint = 0xffffff);
          const anim = this.reelView.getSymbolByPos(reel, symbol)?.getAnimation() as any;
          if (anim !== undefined) {
            anim.tint = 0xffffff;
          }
        }
      }
    }
  }

  /**
   * to hide symbols alpha which are part of winning line
   */
  protected hideAlphaOnWinSymbol(evt: IEvent): void {
    if (this.reelView) {
      this.showAlpha();
      if (evt === null || evt === void 0 ? void 0 : evt.data) {
        for (const winSymData of evt.data) {
          this.reelView.getSymbolByPos(winSymData[0], winSymData[1]).getStatic().tint = 0xffffff;
          const anim = this.reelView.getSymbolByPos(winSymData[0], winSymData[1])?.getAnimation() as any;
          if (anim !== undefined) {
            anim.tint = 0xffffff;
          }

        }
      }
    }
  }
  /**
   * created to create function clone
   */
  protected createRevealSpine(): SpineBase {
    const revealSpineObj: ISpineData = clone(this.json["revealSymbolFG"]);
    revealSpineObj.type = "spine"
    const revealSpine: SpineBase = this.createSpine(revealSpineObj);
    revealSpine.visible = true;
    return revealSpine;

  }
  /**
   * to udpate portrait resizing
   */
  protected resizeOrientation(e?: IObject): void {
    super.resizeOrientation();
    if (ingenuity.deviceEnv.getOrientation() === detectDeviceEnvironmentConstants.constants.ORIENTATION.PORTRAIT) {
      this.x = (innerWidth * SlotConstantsBehavior.HALF_CONVERTER) - (gameConstants.PORTRAIT_SHIFT_X * this.scale.x);
    }
    !ingenuity.deviceEnv.isDesktop && dispatcher.fireEvent(eventDispatchers.ALLIGN_PROGRESS_BALLS_FREEGAME)

  }
  /**
   * to add top bar on top
   */
  protected addButtonPanelOnTop() {
    super.addButtonPanelOnTop();
    dispatcher.fireEvent(SlotEventConstantsBehavior.ADD_TOP_BAR_ON_TOP);
  }
}
